import { render, staticRenderFns } from "./ConversationsListItem.vue?vue&type=template&id=2ce96ce2&scoped=true&"
import script from "./ConversationsListItem.vue?vue&type=script&lang=js&"
export * from "./ConversationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ConversationsListItem.vue?vue&type=style&index=0&id=2ce96ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce96ce2",
  null
  
)

export default component.exports